function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { makeListBuilderSchema, validateAddress, validateEin, validatePhone, validateZip } from "@vestwell-frontend/helpers";
import { format, lastDayOfMonth } from "date-fns";
import { useMemo } from "react";
import * as yup from "yup";
var lastDayOfFebruary = "2/".concat(format(lastDayOfMonth(new Date(new Date().getFullYear(), 1, 1)), 'd'));
export var fiscalYearEnds = [
    {
        label: '12/31',
        value: '12/31'
    },
    {
        label: '11/30',
        value: '11/30'
    },
    {
        label: '10/31',
        value: '10/31'
    },
    {
        label: '9/30',
        value: '9/30'
    },
    {
        label: '8/31',
        value: '8/31'
    },
    {
        label: '7/31',
        value: '7/31'
    },
    {
        label: '6/30',
        value: '6/30'
    },
    {
        label: '5/31',
        value: '5/31'
    },
    {
        label: '4/30',
        value: '4/30'
    },
    {
        label: '3/31',
        value: '3/31'
    },
    {
        label: lastDayOfFebruary,
        value: lastDayOfFebruary
    },
    {
        label: '1/31',
        value: '1/31'
    }
];
export var useValidateOnboardingQuestionnaire = function(args) {
    return useMemo(function() {
        return yup.object(_object_spread_props(_object_spread({
            authSignerFirstName: yup.string().nullable().required('First Name is required'),
            authSignerLastName: yup.string().nullable().required('Last Name is required'),
            authSignerWorkPhone: validatePhone('Invalid phone number').nullable().required('Phone is required'),
            authorizedSignerEmail: yup.string().nullable().email('Invalid email').required('Email is required'),
            companyEntityType: yup.string().nullable().required('Company Entity Type is required'),
            companyName: yup.string().nullable().required('Company Legal Name is required'),
            companyPhoneNumber: validatePhone('Invalid phone number').nullable().required('Phone is required'),
            dayToDayContactEmail: yup.string().nullable().email('Invalid email').required('Email is required'),
            dayToDayContactLastName: yup.string().nullable().required('Last Name is required'),
            dayToDayContactName: yup.string().nullable().required('First Name is required'),
            dayToDayContactNumber: validatePhone('Invalid phone number').nullable().required('Phone is required'),
            doingBusinessAs: yup.string().nullable(),
            employerIdentificationNumber: validateEin('Must be a valid EIN').nullable().required('EIN is required'),
            fiscalYearEnd: yup.string().oneOf(fiscalYearEnds.map(function(param) {
                var value = param.value;
                return value;
            })).nullable().required('Fiscal Year End is required')
        }, !args.isTpa && {
            $adoptionAgreementDoc: yup.array().nullable().when('isConvert', {
                is: 'true',
                then: yup.array().nullable().min(1, 'Document is required').required()
            }),
            // only used for internal questionnaire state
            $priorYear5500Doc: yup.array().nullable().optional(),
            anticipatedHires: yup.number().nullable().required('This field is required'),
            contributionScenario: yup.string().nullable().when('isConvert', {
                is: function(v) {
                    return v !== 'true';
                },
                then: yup.string().nullable().required('This field is required')
            }),
            currentComplianceIssues: yup.array().of(yup.object({
                label: yup.string(),
                value: yup.string().oneOf([
                    'missing_5500',
                    'late_deposits',
                    'missing_contributions',
                    'failed_testing',
                    'other'
                ])
            }).nullable()).when('isConvert', {
                is: 'false',
                then: yup.array().nullable().optional()
            }),
            existingPlanProvider: yup.string().nullable().when('isConvert', {
                is: 'true',
                then: yup.string().nullable().required('Current Provider is required')
            }),
            existingPlanType: yup.string().nullable().when('isConvert', {
                is: 'true',
                then: yup.string().oneOf([
                    '401k',
                    '403b',
                    'SIMPLE_IRA',
                    'SEP_IRA',
                    'defined_benefit',
                    'cash_balance',
                    'other'
                ]).nullable().required('Plan Type is required')
            }),
            highlyCompensatedEmployees: yup.number().nullable().required('This field is required'),
            industryGroup: yup.string().nullable().when('isConvert', {
                is: function(v) {
                    return v !== 'true';
                },
                then: yup.string().nullable().required('This field is required')
            }),
            isConvert: yup.string().oneOf([
                'true',
                'false'
            ]).nullable().required('This field is required'),
            ownerEmployees: yup.number().nullable().required('This field is required'),
            payrollProviderId: yup.string().nullable().required('Payroll Provider is required'),
            payrollSystemOther: yup.string().nullable().when('payrollProviderId', {
                is: '6',
                then: yup.string().nullable().required('Payroll System is required')
            }),
            relativesOfOwnerEmployees: yup.number().nullable().required('This field is required'),
            retirementObjectives: yup.string().nullable().when('isConvert', {
                is: function(v) {
                    return v !== 'true';
                },
                then: yup.string().nullable().required('This field is required')
            })
        }, !args.isMepTpa && {
            controlGroupBusinesses: yup.array().when('isPartOfControlGroup', {
                is: true,
                then: makeListBuilderSchema(yup.object({
                    business: yup.string().required('Company Name is required'),
                    ein: validateEin().required('EIN is required')
                }).required())
            }),
            isPartOfControlGroup: yup.boolean().nullable().required('This field is required'),
            totalEmployeesNumber: yup.number().nullable().required('Number of employees is required')
        }), {
            physicalAddress1: validateAddress().nullable().required('Physical Address is required'),
            physicalAddress2: yup.string().nullable(),
            physicalCity: yup.string().nullable().required('City is required'),
            physicalState: yup.string().nullable().required('State is required'),
            physicalZip: validateZip().nullable().required('Zip is required'),
            stateOfIncorporation: yup.string().nullable().required('State of Incorporation is required'),
            wiredAtWork: yup.boolean().nullable().required('This field is required')
        }));
    }, [
        args.isMepTpa,
        args.isTpa
    ]);
};

//# sourceMappingURL=useValidateOnboardingQuestionnaire.hook.js.map